let googleConfiguration = {};
export function getGoogleConfiguration() {
  return googleConfiguration;
}
export function setGoogleConfiguration(config) {
  googleConfiguration = {
    ...googleConfiguration,
    ...config
  };
}